// Public API for full app
import { App } from './root';
export default App;
